module.exports = __webpack_public_path__ + "static/media/timer-red.efa774ec.svg";